<mat-sidenav-container [hasBackdrop]="true">
  <mat-sidenav
    #right
    mode="over"
    [opened]="isOpen"
    [fixedInViewport]="true"
    [disableClose]="true"
    autoFocus="false"
    position="end"
    class="right-sheet"
  >
    <ng-content select="[sidenav]"></ng-content>
  </mat-sidenav>

  <mat-sidenav-content>
    <section>
      <ng-content select="[content]"></ng-content>
    </section>
  </mat-sidenav-content>
</mat-sidenav-container>
